import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=4534d4dc&scoped=true&"
import script from "./status.js?vue&type=script&lang=js&"
export * from "./status.js?vue&type=script&lang=js&"
import style0 from "./Status.vue?vue&type=style&index=0&id=4534d4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534d4dc",
  null
  
)

export default component.exports